import { combineReducers } 	from 'redux';
import variables from './variables';

export default combineReducers({
	'variables'	: variables
});
